// function create new object from two objects merger
export const MergeObjects = (obj1 = {}, obj2 = {}) => Object.assign({}, obj1, obj2);
export default MergeObjects;
